import { Component, Input } from "@angular/core";

import { NgxLegendItemColor } from "./enum.legend-item-color";

@Component({
  selector: "ngx-chart-legend",
  styleUrls: ["./chart-legend.component.scss"],
  templateUrl: "./chart-legend.component.html",
})
export class ChartLegendComponent {
  /**
   * Take an array of legend items
   * Available iconColor: 'green', 'purple', 'light-purple', 'blue', 'yellow'
   * @type {{iconColor: string; title: string}[]}
   */
  @Input()
  legendItems: { iconColor: NgxLegendItemColor; title: string }[] = [];
}
